import { createAction, props } from '@ngrx/store';

export const SignUp = createAction(
  '[SignUp] SignUp',
  props<{ payload: any }>()
);

export const SignUpSuccess = createAction(
  '[SignUp] SignUp Success',
  props<{ data: any }>()
);

export const SignUpFailure = createAction(
  '[SignUp] SignUp Failure',
  props<{ error: any }>()
);

export const ChangeEMail = createAction(
  '[SignUp] ChangeEMail',
  props<{ payload: any }>()
);

export const ChangeEMailSuccess = createAction(
  '[SignUp] ChangeEMail Success',
  props<{ data: any }>()
);

export const ChangeEMailFailure = createAction(
  '[SignUp] ChangeEMail Failure',
  props<{ error: any }>()
);

export const InitiateVerifyEmail = createAction(
  '[SignUp] InitiateVerifyEmail'
);

export const InitiateVerifyEmailSuccess = createAction(
  '[SignUp] InitiateVerifyEmail Success',
  props<{ data: any }>()
);

export const InitiateVerifyEmailFailure = createAction(
  '[SignUp] InitiateVerifyEmail Failure',
  props<{ error: any }>()
);

export const UpdateEmail = createAction(
  '[SignUp] UpdateEmail',
  props<{ payload: any }>()
);

export const UpdateEmailSuccess = createAction(
  '[SignUp] UpdateEmail Success',
  props<{ data: any }>()
);

export const UpdateEmailFailure = createAction(
  '[SignUp] UpdateEmail Failure',
  props<{ error: any }>()
);


export const ContactUs = createAction(
  '[SignUp] ContactUs',
  props<{ payload: any }>()
);

export const ContactUsSuccess = createAction(
  '[SignUp] ContactUs Success',
  props<{ data: any }>()
);

export const ContactUsFailure = createAction(
  '[SignUp] ContactUs Failure',
  props<{ error: any }>()
);

export const LoadUser = createAction(
  '[SignUp] LoadUser'
);

export const LoadUserSuccess = createAction(
  '[SignUp] LoadUser Success',
  props<{ data: any }>()
);

export const LoadUserFailure = createAction(
  '[SignUp] LoadUser Failure',
  props<{ error: any }>()
);


export const AddInfo = createAction(
  '[SignUp] AddInfo',
  props<{ payload: any }>()
);

export const AddInfoSuccess = createAction(
  '[SignUp] AddInfo Success',
  props<{ data: any }>()
);

export const AddInfoFailure = createAction(
  '[SignUp] AddInfo Failure',
  props<{ error: any }>()
);

export const AddBankAccount = createAction(
  '[SignUp] AddBankAccount',
  props<{ payload: any }>()
);

export const AddBankAccountSuccess = createAction(
  '[SignUp] AddBankAccount Success',
  props<{ data: any }>()
);

export const AddBankAccountFailure = createAction(
  '[SignUp] AddBankAccount Failure',
  props<{ error: any }>()
);

export const AddBankAccountRoutingNumber = createAction(
  '[SignUp] AddBankAccountRoutingNumber',
  props<{ payload: any }>()
);

export const AddBankAccountRoutingNumberSuccess = createAction(
  '[SignUp] AddBankAccountRoutingNumber Success',
  props<{ data: any }>()
);

export const AddBankAccountRoutingNumberFailure = createAction(
  '[SignUp] AddBankAccountRoutingNumber Failure',
  props<{ error: any }>()
);

export const VerificateOrg = createAction(
  '[SignUp] VerificateOrg',
  props<{ payload: any }>()
);

export const VerificateOrgSuccess = createAction(
  '[SignUp] VerificateOrg Success',
  props<{ data: any }>()
);

export const VerificateOrgFailure = createAction(
  '[SignUp] VerificateOrg Failure',
  props<{ error: any }>()
);

export const RedeemCoupon = createAction(
  '[SignUp] Redeem Coupon',
  props<{ payload: any }>()
);

export const RedeemCouponSuccess = createAction(
  '[SignUp] Redeem Coupon Success',
  props<{ data: any }>()
);

export const RedeemCouponFailure = createAction(
  '[SignUp] Redeem Coupon Failure',
  props<{ error: any }>()
);

export const SetPlan = createAction(
  '[SignUp] Set Plan',
  props<{ payload: any }>()
);

export const SetPlanSuccess = createAction(
  '[SignUp] Set Plan Success',
  props<{ data: any }>()
);

export const SetPlanFailure = createAction(
  '[SignUp] Set Plan Failure',
  props<{ error: any }>()
);

export const GetInvoicesDue = createAction(
  '[SignUp] Get InvoicesDue',
  props<{ payload: any }>()
);

export const GetInvoicesDueSuccess = createAction(
  '[SignUp] Get InvoicesDue Success',
  props<{ data: any }>()
);

export const GetInvoicesDueFailure = createAction(
  '[SignUp] Get InvoicesDue Failure',
  props<{ error: any }>()
);
